import type { ComponentChildren } from 'preact';

export function PageHeader({
  title,
  description,
  icon,
  actions,
}: {
  title: string;
  description?: string;
  icon?: ComponentChildren;
  actions?: ComponentChildren;
}) {
  return (
    <header class="mb-5 flex items-start justify-between gap-4">
      <div class="flex items-start gap-3">
        {icon && <div class="mt-0.5 text-muted-foreground">{icon}</div>}
        <div>
          <h1 class="text-xl font-bold tracking-tight">{title}</h1>
          {description && (
            <p class="text-sm text-muted-foreground mt-0.5 max-w-2xl">{description}</p>
          )}
        </div>
      </div>
      {actions && <div class="flex items-center gap-2 shrink-0">{actions}</div>}
    </header>
  );
}
